module.exports = __webpack_public_path__ + "static/media/thieft.0b186c79.png";